import { takeLatest, takeEvery } from 'redux-saga/effects';
import { UPLOAD_PICTURES_TO_CMX, UPLOAD_PICTURES } from 'redux/actions/types';
import { uploadPicturesToCMX } from './uploadPicturesToCMX';
import { postPictureFromApi } from './postPictureFromApi';

export default function* pictureSagas() {
  yield takeEvery(UPLOAD_PICTURES_TO_CMX, uploadPicturesToCMX);
  yield takeLatest(UPLOAD_PICTURES, postPictureFromApi);
}
